<template>
  <div class="login">
    <div class="header">技通天下学习平台</div>
    <div class="content">
      <el-carousel class="carouselBox" height="528px">
        <el-carousel-item v-for="(item,index) in imgUrl" :key="index">
          <img :src="item.image" alt="">
        </el-carousel-item>
      </el-carousel>
      <div class="content-right">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="登录" name="1">
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" :rules="rule" label-width="100px" class="demo-dynamic">
              <el-form-item
                prop="name"
                label-width="0px"
              >
                <el-input placeholder="请输入用户名" v-model="dynamicValidateForm.name"></el-input>
              </el-form-item>
              <el-form-item
                prop="pass"
                label-width="0px"
              >
                <el-input placeholder="请输入密码" type="password" v-model="dynamicValidateForm.pass"></el-input>
              </el-form-item>
              <el-form-item label-width="0px" prop="type">
                <el-checkbox-group v-model="dynamicValidateForm.remember">
                  <el-checkbox label="记住我" name="remember"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label-width="0px">
                <el-button class="buttonInfo" type="primary" @click="loginForm('dynamicValidateForm')">登录</el-button>
              </el-form-item>
            </el-form>
            <div class="goRegister">暂无账号 <span class="register" @click="goRegister">去注册</span></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="footer">
      <a href="https://beian.miit.gov.cn" target="_blank">太原安德智能科技有限公司 版权所有 ICP证：晋ICP备18010754号-12</a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'login',
    data () {
      return {
        imgUrl: [
          {image: '../../static/img/login1.png'},
          {image: '../../static/img/login2.png'},
          {image: '../../static/img/login3.png'}
        ],
        activeName: '1',
        dynamicValidateForm: {
          name: this.$cookie.get('username') ? this.$cookie.get('username') : '',
          pass: this.$cookie.get('password') ? this.$cookie.get('password') : '',
          remember: ''
        },
        rule: {
          name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          pass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        }
      }
    },
    mounted () {

    },
    methods: {
      handleClick (tab, event) {
        this.activeName = tab.name
      },
      goRegister () {
        this.$router.push('/register')
      },
      loginForm (formName) {
        let that = this
        console.log(that.dynamicValidateForm.remember)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.$http({
              method: 'POST',
              url: '/api/renren-fast/app/sys/login',
              data: {
                'userName': that.dynamicValidateForm.name,
                'password': that.dynamicValidateForm.pass,
                'version': 'pc20220418',
                'deviceIdentifier': 'c2-69-1d-f4-f5-20'
              }
            }).then((result) => {
              if (result.data.code === 0) {
                if (that.dynamicValidateForm.remember) {
                  this.$cookie.set('username', that.dynamicValidateForm.name)
                  this.$cookie.set('password', that.dynamicValidateForm.pass)
                }
                sessionStorage.setItem('token', result.data.data.token)
                sessionStorage.setItem('user', JSON.stringify(result.data.data.user))
                // this.$store.dispatch("verification", result.data.data.user)

                this.$router.push('/home')
              } else {
                that.$message.error(result.data.msg)
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login{
    width: 100%;
    height: 100%;
    background: #fff;
    .header{
      width: 100%;
      height: 60px;
      background: #00c5c3;
      padding: 0px 210px;
      font-size: 24px;
      line-height: 60px;
      color: #ffffff;
    }
    .content{
      width: 1000px;
      height: 528px;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255,255,255,1);
      border-radius: 6px;
      box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.11);
      display: flex;
      .carouselBox{
        width: 560px;
      }
      .content-right{
        width: 400px;
        padding: 30px 0px 0px 50px;
        .buttonInfo{
          width: 310px;
          height: 44px;
          background: linear-gradient(90deg,rgba(4,236,234,1) 0%,rgba(0,197,195,1) 100%);
          box-shadow: 0px 2px 22px 0px rgba(0,197,195,0.32);
          font-size: 18px;
          color: #ffffff;
          display: block;
          border: none;
          border-radius: 22px;
          margin-top: 20px;
          cursor: pointer;
        }
        .goRegister{
          width: 310px;
          text-align: end;
          .register{
            color: #00c5c3;
            cursor: pointer;
          }
        }
      }
    }
    .footer{
      width: 100%;
      position: fixed;
      bottom: 20px;
      left: 0px;
      text-align: center;
      a{
        color: #8a979e;
      }
    }
  }
</style>
<style>
  .login .el-carousel__item img{
    width: 100%;
    height: 100%;
  }
  .login .el-tabs__nav-wrap::after{
    width: 0px;
  }
  .login .el-tabs__item{
    font-size: 20px;
    font-weight: bold;
  }
  .login .el-input__inner{
    width: 310px;
    height: 44px;
    font-size: 14px;
    background: rgba(248,249,250,1);
    border-radius: 22px;
    border: none;
    text-indent: 22px;
    margin-bottom: 2px;
    outline: none;
    border: 0;
  }
  .login .el-tabs__content{
    margin-top: 50px;
  }
  .login .el-form-item__error{
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue